export default __webpack_public_path__ + "static/media/newCard.9eda172c.svg";